import Config from '../../config';
import fetch from '../../utils/fetchService';
import { handleErrors, parseAsJson } from '../../utils/requestHelpers';

export const fetchScenarioMembersData = ({
  reportName,
  scenarioId,
  companyCode = '',
  columns = [],
  reportingCurrency,
}) => fetch(
  Config.endpoints.FETCH_SCENARIO_MEMBERS_DATA
    .replace(/:reportName/, reportName)
    .replace(/:scenarioId/, scenarioId)
    .replace(/:companyCode/, companyCode)
    .replace(/:columns/, columns.join(','))
    .replace(/:reportingCurrency/, reportingCurrency)
)
  .then(handleErrors({ errorMessage: 'Fetching scenario members data failed' }))
  .then(parseAsJson);

export const fetchScenarioMembersCompareData = ({
  reportName,
  scenarioId,
  compareScenarioId,
  companyCode = '',
  columns = [],
  reportingCurrency,
}) => fetch(
  Config.endpoints.FETCH_SCENARIO_COMPARE_MEMBERS_DATA
    .replace(/:reportName/, reportName)
    .replace(/:scenarioId/, scenarioId)
    .replace(/:compareScenarioId/, compareScenarioId)
    .replace(/:companyCode/, companyCode)
    .replace(/:reportingCurrency/, reportingCurrency)
    .replace(/:columns/, columns.join(','))
)
  .then(handleErrors({ errorMessage: 'Fetching scenario members data failed' }))
  .then(parseAsJson);
